module.exports = __webpack_public_path__ + "img/tw.970b1815.png";